export default __webpack_public_path__ + "static/media/7H.156a2f08.svg";